import React from 'react';


class CountdownTimer extends React.Component {
  constructor(props) {
    super(props);
    this.timer = null;
    this.state = {
      count: this.props.count,
    };
  }

  componentDidMount() {
    this.tickTimer();
  }

  componentWillUnmount() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }

  tickTimer() {
    const { onTimerFinished } = this.props;
    this.timer = setTimeout(() => {
      this.setState((currentState) => {
        const newCount = currentState.count - 1;

        if (newCount <= 0) {
          onTimerFinished();
        }
        else {
          this.tickTimer();
        }
        return {
          count: newCount,
        };
      });
    }, 1000);
  }

  render() {
    return (
      <span>
        {this.state.count ? this.state.count : null}
      </span>
    );
  }
}

export default CountdownTimer;
